export default class CouldNotSignUpError extends Error {
  constructor(message) {
    super(message);
    Object.setPrototypeOf(this, CouldNotSignUpError.prototype);
  }
}



// WEBPACK FOOTER //
// ./src/advertisers/modules/signup/domain/CouldNotSignUpError.js